/**
 * Material color palette and utilities for the 3D cabinet viewer.
 * Ported from viewer_3d.py MATS object.
 *
 * V1: solid colors only — textures deferred.
 */

import type { PanelDescriptor } from './types';

/** Default color palette (hex) matching the Python viewer defaults */
export const DEFAULT_COLORS = {
  box:       '#c4a574',  // Light oak
  stretcher: '#b8956e',  // Darker oak
  back:      '#d4b896',  // Lighter
  nailer:    '#b8956e',  // Same as stretcher
  shelf:     '#c4a574',  // Same as box
  door:      '#a67c52',  // Darker brown
  drawer:    '#a67c52',  // Same as door
  drawerBox: '#b89a6a',  // Lighter plywood
} as const;

/** Default roughness per component type */
export const DEFAULT_ROUGHNESS: Record<string, number> = {
  box:       0.7,
  stretcher: 0.7,
  back:      0.8,
  nailer:    0.7,
  shelf:     0.6,
  door:      0.5,
  drawer:    0.5,
  drawerBox: 0.75,
};

/** Resolve the color for a panel, using cabinet-level overrides if available */
export function getPanelColor(
  panel: PanelDescriptor,
  cabinetColors: {
    box_color: string;
    door_color: string;
    back_color: string;
    shelf_color: string;
    stretcher_color: string;
  },
): string {
  switch (panel.colorType) {
    case 'box':
      return cabinetColors.box_color || DEFAULT_COLORS.box;
    case 'door':
      return cabinetColors.door_color || DEFAULT_COLORS.door;
    case 'drawer':
      return cabinetColors.door_color || DEFAULT_COLORS.drawer;
    case 'back':
      return cabinetColors.back_color || DEFAULT_COLORS.back;
    case 'shelf':
      return cabinetColors.shelf_color || DEFAULT_COLORS.shelf;
    case 'stretcher':
      return cabinetColors.stretcher_color || DEFAULT_COLORS.stretcher;
    case 'nailer':
      return cabinetColors.stretcher_color || DEFAULT_COLORS.nailer;
    case 'drawerBox':
      return DEFAULT_COLORS.drawerBox;
    default:
      return DEFAULT_COLORS.box;
  }
}

export function getPanelRoughness(panel: PanelDescriptor): number {
  return DEFAULT_ROUGHNESS[panel.colorType] ?? 0.7;
}
